import { Controller } from "stimulus";
import Viewer from "viewerjs";

class ViewerController extends Controller {
  static targets = ["image"]

  connect() {
    this.viewer = new Viewer(this.imageTarget, {})

  }

  show() {
    this.viewer.show()
  }
}

export default ViewerController;